import { render, staticRenderFns } from "./TabContainerControl.vue?vue&type=template&id=78460c54"
import script from "./TabContainerControl.vue?vue&type=script&lang=js"
export * from "./TabContainerControl.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports